export type HapticPattern = 'light' | 'medium' | 'heavy' | 'success' | 'warning' | 'error';
const HAPTIC_PATTERNS: Record<HapticPattern, number | number[]> = {
  light: 12,
  medium: 28,
  heavy: 55,
  success: [30, 50, 30],
  warning: [25, 30, 25],
  error: [60, 35, 60, 35, 60],
};
const supportsVibrate = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  return typeof navigator.vibrate === 'function';
};
export const hapticsSupported: boolean = supportsVibrate();
export const triggerHaptic = (pattern: HapticPattern = 'light'): boolean => {
  if (!supportsVibrate()) return false;
  try {
    return navigator.vibrate(HAPTIC_PATTERNS[pattern]);
  } catch {
    return false;
  }
};
export const cancelHaptic = (): void => {
  if (!supportsVibrate()) return;
  try {
    navigator.vibrate(0);
  } catch {
    /* ignore */
  }
};